import { __decorate } from "tslib";
import { css, html, observable, ref } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { EDITED_COLUMN_FIELD } from '../grid-pro.types';
/**
 * The AG Number Editor element.
 * @public
 * @tagname %%prefix%%-number-editor
 */
export class NumberEditor extends FoundationElement {
    init(params) {
        if (!params)
            return;
        this.params = params;
        this.value = params.value;
        this.actualWidth = params.column.getActualWidth();
    }
    getGui() {
        return this;
    }
    refresh(params) {
        return true;
    }
    getValue() {
        return this.value;
    }
    isPopup() {
        return true;
    }
    afterGuiAttached() {
        this.input.focus();
    }
    changeHandler(event) {
        const value = parseFloat(event.target.value);
        this.value = !isNaN(value) ? value : undefined;
    }
    isCancelBeforeStart() {
        return !!this.params.data[EDITED_COLUMN_FIELD];
    }
}
__decorate([
    observable
], NumberEditor.prototype, "params", void 0);
__decorate([
    observable
], NumberEditor.prototype, "value", void 0);
__decorate([
    observable
], NumberEditor.prototype, "actualWidth", void 0);
/**
 * The AG Number Editor Styles.
 * @public
 */
export const agNumberEditorStyles = css `
  :host {
    display: flex;
  }
`;
/**
 * Get a Design System prefixed Select template.
 * @param designSystem - The design system prefix to use. Defaults to 'foundation'.
 * @returns A Select component template prefixed with the correct design system.
 * @public
 */
export const getNumberEditorTemplate = (designSystem = 'foundation') => html `
  <${designSystem}-number-field
    ${ref('input')}
    withFormatting=${(x) => x.params.withFormatting}
    :options=${(x) => x.params.formatOptions}
    :value=${(x) => (x.value === undefined ? '' : String(x.value))}
    @input=${(x, c) => {
    x.changeHandler(c.event);
}}
    placeholder=${(x) => x.params.placeholder}
    ?disabled=${(x) => x.params.disabled}
    hideStep
    style="width: ${(x) => x.actualWidth}px"
  ></${designSystem}-number-field>
`;
/**
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-number-editor\>
 */
export const foundationNumberEditor = NumberEditor.compose({
    baseName: 'number-editor',
    styles: agNumberEditorStyles,
    template: getNumberEditorTemplate(),
});
